import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOJsonLd from '@/components/feature/SEOJsonLd';
import Hero from './components/Hero';
import HotSection from './components/HotSection';
import CategorySection from './components/CategorySection';
import CTASection from './components/CTASection';

const homePageJsonLd = {
  '@type': 'WebPage',
  name: '韩漫网站 - 在线韩国漫画阅读平台',
  description: '韩漫网站提供在线韩国漫画、好看的韩漫免费在线观看，内容新颖画质佳，海量热门韩漫资源每日更新。',
  url: 'http://guyunqutang.com/',
  inLanguage: 'zh-CN',
  isPartOf: {
    '@type': 'WebSite',
    name: '韩漫网站',
    url: 'http://guyunqutang.com/',
  },
};

export default function Home() {
  return (
    <>
      <SEOJsonLd type="WebPage" data={homePageJsonLd} />
      <header>
        <Navbar />
      </header>
      <main>
        <Hero />
        <HotSection />
        <CategorySection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}